import EA from '../helpers/init';
import Swiper from 'swiper';

export default EA.Methods.sliderCertificate = ($this) => {
    const swiperSlides = $this.querySelector('.swiper');

    const breakpoint = window.matchMedia('(min-width: 1001px)');
    let slider;

    const enableSwiper = function() {
        slider = new Swiper(swiperSlides, {
            speed: 600,
            slidesPerView: 2.2,
            spaceBetween: 16,
            breakpoints: {
                481: {
                    slidesPerView: 3.2,
                    spaceBetween: 16
                },
                601: {
                    slidesPerView: 4,
                    spaceBetween: 16
                },
                801: {
                    slidesPerView: 5.2,
                    spaceBetween: 16
                },
            }
        });
    };
    
    const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
            if ( slider !== undefined ) slider.destroy( true, true );
            return;
        } else if ( breakpoint.matches === false ) {
            return enableSwiper();
        }
    };

    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker();

};
